module.exports = __webpack_public_path__ + "img/logo-rabota-huntica.d2d438f2.svg";